/**
 * @param {number} n
 * @returns {string}
 */
export function fmtMoney(n, includeKsh = true) {
  return (
    (includeKsh ? "Ksh " : "") +
    (n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })
  );
}

/**
 * @param {number} n
 * @param {number} d
 * @returns {string}
 */
export function pct(n, d) {
  return d === 0 ? "0%" : `${Math.round((n / d) * 100)}%`;
}

const defaultvat = 16;
const defaultcLevy = 0;
const defaultsCharge = 0;

/**
 * @param {string} type
 * @param {import("../models/ProductModel").ProductModel} product
 * @param {number} totalL
 * @returns {number}
 */
export function getTaxAmount(type, product, totalL) {
  let v = 0;
  try {
    // TYPES=> SCHARGE, CLEVY otherwise defaults to VAT
    let targetPercent =
      type === "SCHARGE"
        ? (product?.service_charge_percent ?? defaultsCharge)
        : type === "CLEVY"
          ? (product?.cat_levy_percent ?? defaultcLevy)
          : (product?.tax_percent ?? defaultvat);

    let totalPercent =
      (product?.tax_percent ?? defaultvat) +
      (product?.cat_levy_percent ?? defaultcLevy) +
      (product?.service_charge_percent ?? defaultsCharge) +
      100;

    let calculated = (targetPercent / totalPercent) * totalL;
    v = !isNaN(calculated) ? parseFloat(calculated.toFixed(2)) : 0;
  } catch (_) {}
  return v;
}

/**
 * @param {string} ndate
 * @returns {string}
 */
export function convertDate(ndate, includeTime = false) {
  let formattedDate = "";
  try {
    if (includeTime) {
      formattedDate = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "UTC",
      }).format(new Date(ndate));
    } else {
      formattedDate = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        timeZone: "UTC",
      }).format(new Date(ndate));
    }
  } catch (_) {}

  return formattedDate;
}
